import React from 'react';

import PropTypes from 'prop-types';

import { useCurrentProjectId, useCurrentProductId } from '@adsk/alloy-provider';
import { useLocale } from '@adsk/alloy-react-locale';

import EntityMenuItem from '../../../EntityMenuItem';
import getPackageDetailUrl from '../helpers/getPackageDetailUrl';

const PackagesEntityMenuItem = ({ entity, renderIcon }) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));

  const projectId = useCurrentProjectId();
  const productId = useCurrentProductId();

  return (
    <EntityMenuItem
      link={getPackageDetailUrl(projectId, productId, entity.id)}
      label={T.translate('PACKAGE_ID_AND_NAME', {
        displayId: entity.displayId,
        name: entity.name,
      })}
      renderIcon={renderIcon}
    />
  );
};

PackagesEntityMenuItem.propTypes = {
  entity: PropTypes.object,
  renderIcon: PropTypes.func,
};

export default PackagesEntityMenuItem;
